/** Traductions modal modification produit (FR / AR) */
export const editProductModalFr = {
  invalidFileType: 'Erreur de Fichier',
  selectValidImage: 'Veuillez sélectionner un fichier image valide',
  fileTooLarge: 'Erreur de Taille',
  imageMaxSize: 'La taille de l\'image doit être inférieure à 7 Mo',
  productInfo: 'Informations du Produit',
  productName: 'Nom du Produit',
  nameSuggestions: 'Suggestions — cliquer pour choisir :',
  barcode: 'Code-barres',
  barcodePlaceholder: 'Entrez le code-barres (optionnel)',
  category: 'Catégorie',
  selectCategory: 'Sélectionner Catégorie',
  subcategoryRequired: 'Sous-catégorie *',
  selectSubcategory: 'Sélectionner Sous-catégorie',
  typeOptional: 'Type (optionnel)',
  generalType: '— Général —',
  sellingPrice: 'Prix de vente',
  typeRequired: 'Type *',
  selectType: 'Sélectionner Type',
  conservation: 'Conservation',
  selectConservation: 'Sélectionner niveau de conservation',
  conservationLong: 'Conservation longue',
  conservationMedium: 'Conservation moyenne',
  perishable: 'Périssable',
  noExpiry: 'Sans date',
  noExpiryAuto: 'Sans date (automatique)',
  pickingMethod: 'Méthode de Collecte',
  unit: 'Unité',
  selectUnit: 'Sélectionner Unité',
  quantityWithUnit: 'Quantité avec Unité',
  quantityExample: 'ex: 2.5',
  quantityHint: 'Entrez la quantité en {{unit}}',
  skuTitle: 'Code produit actuel',
  productImage: 'Image du Produit',
  removeImage: 'Supprimer l\'Image',
  imageDropHint: 'Cliquez pour sélectionner une image ou glissez-déposez',
  imageFormats: 'PNG, JPG jusqu\'à 7 Mo',
  cancel: 'Annuler',
  saveChanges: 'Sauvegarder les Modifications',
  title: 'Modifier Produit',
  titleDish: 'Modifier un Plat'
};

export const editProductModalAr = {
  invalidFileType: 'خطأ في الملف',
  selectValidImage: 'يرجى اختيار ملف صورة صحيح',
  fileTooLarge: 'خطأ في الحجم',
  imageMaxSize: 'حجم الصورة يجب أن يكون أقل من 7 ميجابايت',
  productInfo: 'معلومات المنتج',
  productName: 'اسم المنتج',
  nameSuggestions: 'اقتراحات — انقر للاختيار:',
  barcode: 'الباركود',
  barcodePlaceholder: 'أدخل الباركود (اختياري)',
  category: 'الفئة',
  selectCategory: 'اختر الفئة',
  subcategoryRequired: 'الفئة الفرعية *',
  selectSubcategory: 'اختر الفئة الفرعية',
  typeOptional: 'النوع (اختياري)',
  generalType: '— عام —',
  sellingPrice: 'سعر البيع',
  typeRequired: 'النوع *',
  selectType: 'اختر النوع',
  conservation: 'الحفظ',
  selectConservation: 'اختر مستوى الحفظ',
  conservationLong: 'حفظ طويل',
  conservationMedium: 'حفظ متوسط',
  perishable: 'قابل للتلف',
  noExpiry: 'بدون تاريخ',
  noExpiryAuto: 'بدون تاريخ (تلقائي)',
  pickingMethod: 'طريقة الجمع',
  unit: 'الوحدة',
  selectUnit: 'اختر الوحدة',
  quantityWithUnit: 'الكمية مع الوحدة',
  quantityExample: 'مثال: 2.5',
  quantityHint: 'أدخل الكمية بال{{unit}}',
  skuTitle: 'رمز المنتج الحالي',
  productImage: 'صورة المنتج',
  removeImage: 'إزالة الصورة',
  imageDropHint: 'انقر لاختيار صورة أو اسحب وأفلت',
  imageFormats: 'PNG, JPG حتى 7 ميجابايت',
  cancel: 'إلغاء',
  saveChanges: 'حفظ التغييرات',
  title: 'تعديل المنتج',
  titleDish: 'تعديل طبق'
};
